import HTTP from '../../../../api/AxiosConfig';

export const getHistoryRecords = (request) =>
    HTTP.post('/history', request);

export const getGroupedHistoryRecords = (request) =>
    HTTP.post('/history/grouped-by-date', request);